import { render, staticRenderFns } from "./email-input.vue?vue&type=template&id=140b8f14&scoped=true"
import script from "./email-input.vue?vue&type=script&lang=js"
export * from "./email-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b8f14",
  null
  
)

export default component.exports